import { Beneficiaries } from '../../EditAssetForm.meta';
import {
  AccountAssetDTO,
  AccountAssetSimulatedDTO,
} from '../../../../../../api/useEstatePlanningExplanationQuery';

export interface FormValues extends AccountAssetDTO, AccountAssetSimulatedDTO {
  Owner: string | null;
}

export interface Body {
  Id: string;
  SimulatedAccountType?: number;
  EntityId?: string;
  Owner: string | null;
  Beneficiaries: Beneficiaries;
  SimulatedAccountId?: string;
}

export const formToBody = (values: FormValues): Body => {
  const {
    ContingentBeneficiaries,
    PrimaryBeneficiaries,
    LastUpdated,
    Id,
    Owner,
    EntityId,
    SimulatedAccountId,
    Type,
  } = values;

  return {
    Id,
    EntityId,
    SimulatedAccountType: Type,
    Owner,
    SimulatedAccountId,
    Beneficiaries: {
      ContingentBeneficiaries: ContingentBeneficiaries || [],
      PrimaryBeneficiaries: PrimaryBeneficiaries || [],
      LastBeneficiaryUpdate: LastUpdated,
    },
  };
};

export const ACCOUNT_ASSET_FORM_ID = 'account--asset--form';
